import React, { useState } from "react";
import ScrappedCasingTyresGraph from "../components/scrap-dashboard/ScrappedCasingTyresGraph";
import ValidatedTyresPendingBillingGraph from "../components/scrap-dashboard/ValidatedTyresPendingBillingGraph";
import BilledLiftedTyresGraph from "../components/scrap-dashboard/BilledLiftedTyresGraph";
import ValidatedTyresResourceTable from "../components/scrap-dashboard/ValidatedTyresResourceTable";
import ScrapAnalysisFleetWise from "../components/scrap-dashboard/ScrapAnalysisFleetWise";
import ScrapTyreKmReportTable from "../components/scrap-dashboard/ScrapTyreKmReportTable";
import ValidatedTyresModal from "../components/scrap-dashboard/ValidatedTyresModal";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const ScrappingCasingDashboard = () => {
  const rowsPerPage = 5;
  const [selectedResource, setSelectedResource] = useState(null);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div className="w-full min-h-screen bg-transparent p-4 md:p-8 flex flex-col items-center gap-8">
        <ValidatedTyresPendingBillingGraph />

        <div className="w-full max-w-[1400px] grid grid-cols-1 xl:grid-cols-2 gap-6">
          <ScrappedCasingTyresGraph />
          <BilledLiftedTyresGraph />
        </div>

        <ValidatedTyresResourceTable
          rowsPerPage={rowsPerPage}
          onRowClick={setSelectedResource}
        />

        <div
          className="w-full max-w-[1400px] bg-white rounded-3xl shadow-[0_4px_20px_rgba(0,0,0,0.05)] overflow-hidden flex flex-col gap-12"
          style={{ border: "1.5px solid #C6C6C6", padding: "32px" }}
        >
            <ScrapAnalysisFleetWise noCard={true} rowsPerPage={rowsPerPage} />
            <ScrapTyreKmReportTable noCard={true} />
        </div>

        <ValidatedTyresModal
          isOpen={!!selectedResource}
          onClose={() => setSelectedResource(null)}
          resourceName={selectedResource}
        />
      </div>
    </LocalizationProvider>
  );
};

export default ScrappingCasingDashboard;

